import { useEffect, useState } from "react";
import Api from "lib/api/httpRequestHelper";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  Card,
  CardMedia,
} from "@material-ui/core";
import EmailWithCopyAndSend from "components/Texts/EmailWithCopyAndSend";
import PhoneWithWhatsapp from "components/Texts/PhoneWithWhatsapp";
import { Close, Handshake } from "@mui/icons-material";
import karstenImage from "assets/img/logos/karstenWhite.webp";
import trussardiImage from "assets/img/logos/trussardiWhite.webp";
import KarstenDecorImage from "assets/img/logos/karstenDecor.webp";
import LoadingData from "components/Loading/LoadingData";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

export default function RepresentativesCard({
  storeId,
  setOpenedModal,
  setType,
}) {
  const [searching, setSearching] = useState(false);
  const [representantes, setRepresentantes] = useState();
  const [selectedRep, setSelectedRep] = useState();
  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);
    try {
      const [
        representanteKarsten,
        representanteTrussardi,
        representanteKarstenDecor,
      ] = await Promise.all([
        Api.get(
          "representative",
          "commercialstructure",
          "?idPessoaLoja=" + storeId + "&idMarca=" + 1,
          true
        ),
        Api.get(
          "representative",
          "commercialstructure",
          "?idPessoaLoja=" + storeId + "&idMarca=" + 2,
          true
        ),
        Api.get(
          "representative",
          "commercialstructure",
          "?idPessoaLoja=" + storeId + "&idMarca=" + 3,
          true
        ),
      ]);
      const representantesList = [
        ...(representanteKarsten?.Result || []),
        ...(representanteKarstenDecor?.Result || []),
        ...(representanteTrussardi?.Result || []),
      ];
      setRepresentantes(representantesList);
      setSelectedRep(representantesList[0] || null);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar informações de representantes:", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  const logos = {
    Karsten: karstenImage,
    Trussardi: trussardiImage,
    KarstenDecor: KarstenDecorImage,
  };

  const details = [
    { label: "Código ERP", value: selectedRep?.CodigoErp },
    { label: "CNPJ", value: selectedRep?.CNPJ },
    { label: "Razão Social", value: selectedRep?.Nome },
    { label: "Nome Contato", value: selectedRep?.Nome },
    { label: "Marca", value: selectedRep?.Marca },
    {
      label: "Telefone 1",
      value: <PhoneWithWhatsapp phone={selectedRep?.Telefone1} />,
    },
    {
      label: "Telefone 2",
      value: <PhoneWithWhatsapp phone={selectedRep?.Telefone2} />,
    },
    {
      label: "Email",
      value: <EmailWithCopyAndSend email={selectedRep?.Email} />,
    },
  ];

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open onClose={() => setOpenedModal(null)} maxWidth={"md"} fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Handshake style={{ marginRight: "12px" }} />
            Representantes
          </Typography>
          <IconButton onClick={() => setOpenedModal(null)}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando dados de representantes..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container spacing={2}>
            {representantes?.map((rep) => (
              <Grid item xs={4} key={rep.id}>
                <Card
                  style={{
                    padding: "0 2rem",
                    border: `1px solid ${
                      selectedRep.id === rep.id ? "#13294B" : "#C2C2C2"
                    }`,
                    backgroundColor:
                      selectedRep.id === rep.id ? "#13294B" : "#C2C2C2",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedRep(rep)}
                >
                  <CardMedia
                    component="img"
                    alt={rep.Marca}
                    height="60"
                    src={logos[rep.Marca.replace(" ", "")]}
                    title={rep.Marca}
                    style={{
                      objectFit: "contain",
                      padding: "8px",
                      filter:
                        selectedRep.id !== rep.id ? "grayscale(100%)" : "none",
                      opacity: selectedRep.id !== rep.id ? 0.6 : 1,
                    }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>

          <Grid container direction="column">
            <Grid item xs={12}>
              {details.map(({ label, value }) => (
                <Typography key={label} variant="caption">
                  <strong>{label}:</strong> {value}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </DialogContent>
      )}
      <DialogActions>
        <Button
          variant="outlined"
          style={{ marginTop: "1.5rem" }}
          onClick={() => setOpenedModal(null)}
        >
          Fechar
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: "1.5rem" }}
          onClick={() => {
            setOpenedModal("ALTERACAO");
            setType("REPRESENTANTE");
          }}
        >
          Solicitar alteração
        </Button>
      </DialogActions>
    </Dialog>
  );
}
